module.exports = __webpack_public_path__ + "img/分支箱.b89f76f8.png";